import type { ImpactDistributionDataEntry } from "@jugl-web/domain-resources/analytics/components/ImpactDistributionWidget";
import {
  ImpactOverviewBody,
  type ImpactOverviewWidgetDataEntry,
} from "@jugl-web/domain-resources/analytics/components/ImpactOverviewWidget";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { WidgetContainer } from "../WidgetContainer";
import { WidgetContainerTitle } from "../WidgetContainerTitle";
import { ReactComponent as QuestionIcon } from "./assets/question.svg";

export const ImpactOverviewWidget: FC<{
  data: ImpactOverviewWidgetDataEntry[];
  impactDistributionData: ImpactDistributionDataEntry[];
  impactDetailsById: Record<string, ImpactDistributionDataEntry>;
}> = ({ data, impactDistributionData, impactDetailsById }) => {
  const { t } = useTranslations();

  return (
    <WidgetContainer className="flex h-[738px] flex-col items-stretch gap-8 px-0">
      <WidgetContainerTitle
        className="px-5"
        icon={<QuestionIcon className="shrink-0" />}
        title={t({
          id: "cx-page.topics-impact-overview",
          defaultMessage: "Topics & Impact overview",
        })}
      />
      <ImpactOverviewBody
        data={data}
        impactDistributionData={impactDistributionData}
        impactDetailsById={impactDetailsById}
      />
    </WidgetContainer>
  );
};
